import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {GranServicioDePTWService}from '../gran-servicio-de-ptw.service'
import {ServicioLoadersAlertasService}from '../servicio-loaders-alertas.service'
import * as firebase from 'firebase'
import { AlertController, ToastController,LoadingController } from '@ionic/angular';
import * as moment from 'moment';

@Component({
  selector: 'app-modal-buscar-trabajador',
  templateUrl: './modal-buscar-trabajador.page.html',
  styleUrls: ['./modal-buscar-trabajador.page.scss'],
})
export class ModalBuscarTrabajadorPage implements OnInit {

  @Input() arrayDeEmpleados;
 
  arrayderesultados=[]
  trabajadorexiste=true
  tipoID=''
  cedula=''
  nombre=''
  telefono=''
  arl=''
  fechaAfiliacionARL=''
  urlParafiscales=''

   //--variables de subir parafiscales
   changedData=true
   percentage=0;


  constructor(public granServicioDePTWService:GranServicioDePTWService, public modalCtrl: ModalController, public alertController: AlertController, public toast: ToastController, public loadingController: LoadingController, public servicioLoadersAlertasService: ServicioLoadersAlertasService) { }

  ngOnInit() {
    this.tipoID=''
    this.cedula=''
    this.nombre=''
    this.telefono=''
    this.arl=''
    this.fechaAfiliacionARL=''
    this.urlParafiscales=''
  }


  //limpiamos caracteres no numericos para el numero de cedula
  limpiacedula(entrada) {
    let cleanString = entrada.replace(/[-|&;$%@"'.qwertyuioplkjhgfdsazxcvbnm#!^*()_+=¡!?¿`~,%<>()+,]/g, "");
  }


  validaSiTrabajadorYaEstaSeleccionado(){
    if(this.tipoID==''){this.servicioLoadersAlertasService.alerta("Tipo id. no seleccionado","Seleccione un tipo de identificación para poder continuar")}
    else if (this.tipoID!=''){
       //primero revisamos si esa actividad ya existe en el array de actividades 
       if (this.arrayDeEmpleados.filter(e => e.id == this.tipoID+this.cedula).length > 0) {
        /* array contains the element we're looking for */
        this.servicioLoadersAlertasService.alerta("Trabajador ya asignado","Este trabajador ya ha sido asignado al permiso de trabajo. Ingrese otra identificación o presione Cancelar")
      }else{
        this.buscarTrabajador()
      }
    } 
  }


  buscarTrabajador(){
    this.servicioLoadersAlertasService.presentLoading("Buscando trabajador en la base de datos...")

    let docIdParaQuery = this.tipoID+this.cedula
    let docRef = firebase.firestore().collection("trabajadores").doc(docIdParaQuery);
    docRef.get().then((doc)=>{
      //si el trabajador existe, lo metemos dentro del documento de solicitud en el campo de arraydeempleados
      if(doc.exists){
        firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
          // con firebase.firestore.FieldValue.arrayUnion añadimos un item al array de empleados
          arrayDeEmpleados: firebase.firestore.FieldValue.arrayUnion({
            id:doc.id,
            arraydeactividades:[],
            // datosTrabajador:doc.data()
          })
        }).then(()=>{
          this.loadingController.dismiss()
          this.modalCtrl.dismiss({trabajadorexiste:true})
        })
      
        
      }else{
        //si no existe le mandamos el tipo y la cedula al paso 3 para que los mande de nuevo al modal de crear trabajador
        this.loadingController.dismiss()
        // this.servicioLoadersAlertasService.alerta("Nuevo trabajador","Ingrese a continuación los datos del nuevo trabajador")
        this.modalCtrl.dismiss({trabajadorexiste:false,tipoId:this.tipoID,cedula:this.cedula})
      }
    }).catch((err)=>{
      this.loadingController.dismiss()
      this.servicioLoadersAlertasService.alerta("Error",err)
    })
  }




    cancelar(){
     
        this.modalCtrl.dismiss();
      
    }


 


  


}//fin de clase
